import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "../css/User.css";
import { Autocomplete, TextField } from "@mui/material";
import CloneUser from "./CloneUser";
import ic_new_user from "../img/ic_new_user.png";
import ic_list from "../img/ic_list.png";
import ic_clone from "../img/ic_clone.png";

function ListOfUsers(props) {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const CURRENT_USER_OBJECT = JSON.parse(localStorage.getItem("currentUser"));
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
  const {
    setCurrentUserToBeEdited,
    setShowClonePopup,
    setClickedUserFromList,
    setShowUploadPopup,
    setCurrentDetailsForImageUpload,
    setShowViewPopup,
  } = props;
  const {
    data: getData,
    loading: getLoading,
    error: getError,
    get: getUsers,
  } = useApi();
  const [filteredUserList, setFilteredUserList] = useState(null);
  const [selectedRole, setSelectedRole] = useState("ALL");
  const [searchTextFilterTable, setSearchTextFilterTable] = useState("");
  const [showListOfRoles, setShowListOfRoles] = useState(false);
  const [arrayORoles, setArrayORoles] = useState(null);

  useEffect(() => {
    if (getData) {
      setFilteredUserList(getData);
    }
  }, [getData]);

  useEffect(() => {
    getUsers(`${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`);
  }, []);

  const callGetUsers = () => {
    if (selectedRole) {
      if (selectedRole?.trim()?.toUpperCase() === "ALL") {
        getUsers(`${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`);
      } else {
        getUsers(
          `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/USERLIST/${
            selectedRole || "-"
          }/ROLE`,
        );
      }
    }
  };

  useEffect(() => {
    callGetUsers();
  }, [selectedRole]);

  useEffect(() => {
    if (searchTextFilterTable?.length > 0) {
      const filtered = getData?.filter((user) =>
        user.loginame
          .toLowerCase()
          .includes(searchTextFilterTable.toLowerCase()),
      );
      setFilteredUserList(filtered);
    } else {
      setFilteredUserList(getData);
    }
  }, [searchTextFilterTable]);

  return (
    <div>
      <h2
        className="flex items-center text-xl text-blue-500 mt-8"
        style={{ color: "#00ACC1" }}
      >
        <img className="w-10 me-2" src={ic_list} /> User List
      </h2>

      <div className="flex justify-between relative mt-4">
        <input
          placeholder="Search user"
          className="border border-gray-300 rounded px-3 py-2 "
          onChange={(e) => setSearchTextFilterTable(e.target.value)}
        />

        <span
          className="border rounded border-red-500 text-red-500 px-2 flex items-center"
          onClick={() => setShowListOfRoles((prev) => !prev)}
        >
          {selectedRole}
          <svg
            className="ms-1"
            width="20"
            height="10"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L5 5L9 1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>

        {showListOfRoles && (
          <div
            className="shadow border"
            style={{
              backgroundColor: "#ffffff",
              width: "200px",
              height: "200px",
              position: "absolute",
              padding: "10px",
              right: "0px",
              top: "42px",
              overflowY: "scroll",
              zIndex: 3,
            }}
          >
            <div>
              {arrayORoles?.map((item) => {
                return (
                  <p
                    className="border-b p-2"
                    onClick={() => {
                      setShowListOfRoles(false);
                      setSelectedRole(item?.ROLE);
                    }}
                  >
                    {item.ROLE}
                  </p>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* sir said no employee name needed only code to be shown in list */}
      <div
        class="overflow-x-auto mt-2"
        style={{ height: "50vh", overflowY: "scroll" }}
      >
        <table
          class="min-w-full divide-y divide-gray-200 border border-gray-300"
          style={{ "border-collapse": "collapse" }}
        >
          <thead>
            <tr class="bg-gray-100" style={{ position: "sticky", top: "0px" }}>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                Name
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                Password
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                Role
              </th>

              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                Emp Code
              </th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">
                Salesman
              </th>
              <th class="px-6 py-3 text-right text-xs font-medium text-gray-700 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            {filteredUserList?.map((item) => {
              return (
                <tr class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {item.loginame}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {item.loginpwd}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {item.accessgrp}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {item.empcode}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <div>
                      <p> {item.sman_name}</p>
                      {item.sales_man && (
                        <p style={{ color: "blue" }}> {item.sales_man}</p>
                      )}
                    </div>
                  </td>

                  <td class=" py-4">
                    <div className="flex ">
                      <a
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          marginLeft: "10px",
                        }}
                        className=" px-1"
                        href={`user_rights?user_name=${encodeURIComponent(
                          item.loginame?.trim(),
                        )}`}
                        class="text-black-600 hover:text-black-900"
                      >
                        <svg
                          style={{ marginRight: "4px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          class="feather feather-eye"
                        >
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                        Rights
                      </a>
                      <button
                        onClick={() => {
                          setClickedUserFromList(item);
                          setShowClonePopup((prev) => !prev);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          marginLeft: "10px",
                        }}
                        className="  px-1"
                        class="text-blue-800 hover:text-blue-900"
                      >
                        <img
                          width="24"
                          height="24"
                          className=""
                          src={ic_clone}
                        />
                        Clone
                      </button>

                      <button
                        onClick={() => setCurrentUserToBeEdited(item)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          marginLeft: "10px",
                        }}
                        className="  px-1"
                        class="text-blue-600 hover:text-blue-900"
                      >
                        <svg
                          style={{ marginRight: "4px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          class="feather feather-edit"
                        >
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                        Edit
                      </button>
                      <a
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          marginLeft: "10px",
                        }}
                        className="  px-1"
                        href="#"
                        class="text-red-600 hover:text-red-900"
                      >
                        <svg
                          style={{ marginRight: "4px" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          class="feather feather-trash"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                          <path d="M10 11v6" />
                          <path d="M14 11v6" />
                          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                        </svg>
                        Delete
                      </a>
                    </div>
                    <div className="flex mt-2">
                      {/* Seal not needed because athul will do it department wise  */}
                      {/* <button
                        onClick={() => {setShowViewPopup(true); setCurrentDetailsForImageUpload({userObject:item, image_doc_type:"SEAL"})}}
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                      >
                        View Seal
                      </button>
                      
                      <button
                        onClick={() => {setShowUploadPopup(true); setCurrentDetailsForImageUpload({userObject:item, image_doc_type:"SEAL"})}}
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                      >
                        Upload Seal
                      </button> */}

                      <button
                        onClick={() => {
                          setShowViewPopup(true);
                          setCurrentDetailsForImageUpload({
                            userObject: item,
                            image_doc_type: "SIGNATURE",
                          });
                        }}
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                      >
                        View Signature
                      </button>

                      <button
                        onClick={() => {
                          setShowUploadPopup(true);
                          setCurrentDetailsForImageUpload({
                            userObject: item,
                            image_doc_type: "SIGNATURE",
                          });
                        }}
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:text-blue-900 transition-colors ml-2"
                      >
                        Upload Signature
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ListOfUsers;
